import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router';
import dynamicfunction from '../../utils/dynamicfunction';
import { loginUser } from '../../store/actions/authActions';
import { getContentKeyAccToLang } from '../../utils/utils';
import { setUsername } from '../../store/slices/authSlice';
import { setItem } from '../../utils/storage_services';
import { setFunds } from '../../store/slices/fund-slice';
import { setLanguage } from '../../store/slices/contentSlice';
import { languages } from '../../config/config';

export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { TextWeight, isArabic } = dynamicfunction();

  const { authLoading, username } = useSelector((state) => state.auth);
  const { authContent } = useSelector((state) => state.content);
  
  const passwordRef = useRef();
  
  const [searchParams, setSearchParams] = useSearchParams();
  const [isRemembered, setIsRemembered] = useState(username ? true : false);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(authContent?.web_login?.data?.attributes, key, isArabic);
  };

  useEffect(()=>{
  const languageId = searchParams.get('languageId');
    if (languageId) dispatch(setLanguage({ language: languageId == 3 ? languages?.eng : languages?.arb }))
  }, [searchParams])

  const handleLogin = async (values) => {
    try {
      const apiData = {
        userName: values?.username?.trim()?.toLowerCase(),
        password: values?.password,
        languageId: isArabic ? 4 : 3,
        deviceType: 'Web',
      };

      if (isRemembered) {
        dispatch(setUsername(values?.username));
        setItem('username', values?.username);
      } else {
        dispatch(setUsername(null));
        setItem('username', null);
      }

      dispatch(
        loginUser(apiData, (response) => {
          dispatch(setFunds(null));
          navigate('/otp', { state: { clientId: response?.result?.clientId, isLogin: true } });
        }),
      );
    } catch (error) {}
  };

  return {
    passwordRef,
    TextWeight,
    authLoading,
    handleLogin,
    getContentKey,
    navigate,
    isRemembered,
    setIsRemembered,
    username,
    isArabic,
  };
};
